"use client";
import ExpertListCard from "@/app/fitness/dietitian-expertlist/components/ExpertListCard/ExpertListCard";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import Detailslist from "@/components/Detailslist/Detailslist";
import Treatments from "@/components/Treatments/Treatments";
import { expertFilter } from "@/utils/data";
import React from "react";

const ExpertList = ({ selectAllExperts, type }) => {
  const props = {
    heading: "Search accordingly your convenience",
    filterData: expertFilter,
  };

  const data = selectAllExperts;
  return (
    <>
      <BreadCrumbs />
      <Detailslist props={props}>
        {data?.data?.map((listitem, i) => {
          return <ExpertListCard listitem={listitem} key={i} type={type} />;
        })}
      </Detailslist>
      <div style={{ marginTop: "40px" }}>
        <Treatments numOfRows={2} />
      </div>
    </>
  );
};

export default ExpertList;
